import React from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import Iframe from 'react-iframe';
import urlParser from 'js-video-url-parser';
import View from './view';

const extractUrl = (source): string | undefined => {
  if (typeof source === 'string') {
    return source;
  }
  if (Array.isArray(source)) {
    return extractUrl(source[0]); // TODO: should pick the best url, based on screen size etc.
  }
  if (source && typeof source === 'object') {
    return source.uri;
  }
  return undefined;
};

const embedUrl = (source): string | undefined => {
  const url = extractUrl(source);
  // only Youtube is supported
  return url
    ? `https://www.youtube.com/embed/${urlParser.parse(url)?.id}`
    : undefined;
};

type ContainerProps = {
  size?: {
    width?: string;
    height?: string;
  };
};

const Container: StyledComponent<
  React.ComponentProps<typeof View> & ContainerProps
> = styled(View)((props: ContainerProps) => ({
  flexBasis: 'auto',
  overflow: 'hidden',
  zIndex: 0,
  ...(props.size ?? {}),
}));

type Source = {
  uri: string;
};
type Props = {
  source: string | Source | Source[];
  className?: string;
  height: string;
};

export default function IFrame({ source, className, height }: Props) {
  const url = embedUrl(source);
  if (!url) {
    return null;
  }
  return (
    <Container size={{ height, width: 'auto' }} className={className}>
      <Iframe
        url={url}
        height={height}
        display="block"
        position="relative"
        frameBorder={0}
      />
    </Container>
  );
}
